import {
  useQuery,
} from '@tanstack/react-query'
import {
  referralService,
} from '../services/api'

/**
 * The user's referral standing plus the active tiered programme. Shared by
 * ReferralStrip and ReferralLinkModal so the page-level fetch is deduped by
 * React Query's shared key.
 *
 * `enabled` lets a caller defer the fetch (e.g. the spotlight only loads
 * while open).
 */
export function useReferralStatus({ enabled = true }: { enabled?: boolean } = {}) {
  const query = useQuery({
    queryKey: ['referral-status'],
    queryFn: () => referralService.getStatus(),
    enabled,
  })

  return {
    status: query.data ?? null,
  }
}
